import axios from 'axios';

import {
  ScheduledOfferModel,
  ScheduledOfferPayload,
  ScheduledOfferState,
} from '../models/ScheduledOfferModel';
import {
  PROMO_RESULTS_ORDERS_PER_PAGE,
  PromoResultsDateFilters,
  PromoResultsDetail,
  PromoResultsFilters,
  PromoResultsSummary,
} from '../models/ScheduledOfferResultsModel';

const API_URL = process.env.REACT_APP_API_URL;
const SCHEDULED_OFFERS_URL = `${API_URL}/api/scheduled-product-pricing/`;
const SCHEDULED_OFFERS_RESULTS_URL = `${API_URL}/api/scheduled-product-pricing-results/`;

export function listScheduledOffers(): Promise<{
  data: ScheduledOfferModel[];
}> {
  return axios.get(SCHEDULED_OFFERS_URL);
}

export function getScheduledOffer(
  id: number
): Promise<{ data: ScheduledOfferModel }> {
  return axios.get(`${SCHEDULED_OFFERS_URL}${id}/`);
}

export function createScheduledOffer(
  payload: ScheduledOfferPayload
): Promise<{ data: ScheduledOfferModel }> {
  return axios.post(SCHEDULED_OFFERS_URL, payload);
}

export function updateScheduledOffer(
  id: number,
  payload: Partial<ScheduledOfferPayload>
): Promise<{ data: ScheduledOfferModel }> {
  return axios.patch(`${SCHEDULED_OFFERS_URL}${id}/`, payload);
}

export function toggleScheduledOfferState(
  id: number,
  state: ScheduledOfferState
): Promise<{ data: ScheduledOfferModel }> {
  return axios.patch(`${SCHEDULED_OFFERS_URL}${id}/`, { state });
}

export function getScheduledOffersResults(
  filters: PromoResultsFilters
): Promise<{ data: PromoResultsSummary }> {
  return axios.get(SCHEDULED_OFFERS_RESULTS_URL, { params: filters });
}

export function getScheduledOfferResults(
  id: number,
  filters: PromoResultsDateFilters,
  page: number
): Promise<{ data: PromoResultsDetail }> {
  return axios.get(`${SCHEDULED_OFFERS_RESULTS_URL}${id}/`, {
    params: {
      ...filters,
      limit: PROMO_RESULTS_ORDERS_PER_PAGE,
      offset: (page - 1) * PROMO_RESULTS_ORDERS_PER_PAGE,
    },
  });
}
